import { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useSelector } from 'react-redux'

interface KeyMarket {
    phaseKeyMarkets?: { label?: string; code?: string }[]
}

interface Strategy {
    _id: string
    organizationId: string
    product?: string
    indication?: string
    keyMarkets?: KeyMarket[]
    sourceId?: string
    // Training copy inside a real customer org; see isSandbox on the server Strategy schema.
    isSandbox?: boolean
}

interface State {
    strategy: Strategy | null
}

export const useStrategy = (): Strategy | null => {
    const history = useHistory()

    const strategy = useSelector((state: State) => state.strategy)
    const isStrategySelected = Boolean(strategy?._id)

    useEffect(() => {
        if (!isStrategySelected) {
            history.push('/roadmaps')
        }
    }, [isStrategySelected, history])
    return strategy
}
